import React from "react";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import { withRouter } from "react-router";
import { userSignout } from "../../../actions";
import { Link } from "react-router-dom";

const SignInOutButton = ({ auth, dispatch, history }) => {
  if (!auth.isAuthenticated)
    return (
      <Button color="primary" variant="contained" component={Link} to="/login">
        Sign In
      </Button>
    );
  const handleClick = () => {
    history.push("/signout-thankyou");
    dispatch(userSignout());
  };
  return (
    <Button color="primary" onClick={handleClick} className="signOutBtn">
      Sign Out
    </Button>
  );
};
const mapStateToProps = state => {
  return {
    auth: state.auth
  };
};

const wrSignInOutButton = withRouter(SignInOutButton);

export default connect(mapStateToProps)(wrSignInOutButton);
